(() => {
  const INIT_KEY = 'howdyDawgDawgReportInitialized';
  const INIT_FN = 'howdyDawgInitDawgReport';

  if (window[INIT_KEY]) {
    window[INIT_FN]?.();
    return;
  }

  window[INIT_KEY] = true;

  const FORECAST_ENDPOINT = 'https://api.open-meteo.com/v1/forecast';
  const CACHE_PREFIX = 'hd-dawg-report-v2';
  const CACHE_TTL = 15 * 60 * 1000;
  const SHRED_SUIT_URL = '/collections/shred-suits';
  const HALF_ZIP_URL = '/products/hot-dawg-half-zip';
  let cameraSourcesRequest;
  let cameraPanelId = 0;

  const RESORTS = [
    { name: 'Alta', state: 'UT', lat: 40.5888, lon: -111.6373 },
    { name: 'Snowbird', state: 'UT', lat: 40.5810, lon: -111.6560 },
    { name: 'Brighton', state: 'UT', lat: 40.5980, lon: -111.5832 },
    { name: 'Solitude', state: 'UT', lat: 40.6190, lon: -111.5910 },
    { name: 'Park City', state: 'UT', lat: 40.6514, lon: -111.5080 },
    { name: 'Deer Valley', state: 'UT', lat: 40.6374, lon: -111.4783 },
    { name: 'Snowbasin', state: 'UT', lat: 41.2160, lon: -111.8569 },
    { name: 'Powder Mountain', state: 'UT', lat: 41.3794, lon: -111.7805 },
    { name: 'Brian Head', state: 'UT', lat: 37.7022, lon: -112.8499 },
    { name: 'Breckenridge', state: 'CO', lat: 39.4808, lon: -106.0660 },
    { name: 'Vail', state: 'CO', lat: 39.6061, lon: -106.3550 },
    { name: 'Beaver Creek', state: 'CO', lat: 39.6042, lon: -106.5165 },
    { name: 'Keystone', state: 'CO', lat: 39.6064, lon: -105.9436 },
    { name: 'Arapahoe Basin', state: 'CO', lat: 39.6423, lon: -105.8718 },
    { name: 'Copper Mountain', state: 'CO', lat: 39.5022, lon: -106.1516 },
    { name: 'Winter Park', state: 'CO', lat: 39.8868, lon: -105.7625 },
    { name: 'Steamboat', state: 'CO', lat: 40.4572, lon: -106.8045 },
    { name: 'Aspen Snowmass', state: 'CO', lat: 39.2083, lon: -106.9490 },
    { name: 'Telluride', state: 'CO', lat: 37.9375, lon: -107.8123 },
    { name: 'Crested Butte', state: 'CO', lat: 38.8990, lon: -106.9650 },
    { name: 'Loveland', state: 'CO', lat: 39.6800, lon: -105.8970 },
    { name: 'Eldora', state: 'CO', lat: 39.9372, lon: -105.5826 },
    { name: 'Monarch Mountain', state: 'CO', lat: 38.5120, lon: -106.3320 },
    { name: 'Jackson Hole', state: 'WY', lat: 43.5875, lon: -110.8279 },
    { name: 'Grand Targhee', state: 'WY', lat: 43.7880, lon: -110.9590 },
    { name: 'Sun Valley', state: 'ID', lat: 43.6971, lon: -114.3517 },
    { name: 'Bogus Basin', state: 'ID', lat: 43.7640, lon: -116.1020 },
    { name: 'Schweitzer', state: 'ID', lat: 48.3670, lon: -116.6230 },
    { name: 'Tamarack', state: 'ID', lat: 44.6690, lon: -116.1240 },
    { name: 'Big Sky', state: 'MT', lat: 45.2850, lon: -111.4010 },
    { name: 'Whitefish', state: 'MT', lat: 48.4800, lon: -114.3580 },
    { name: 'Bridger Bowl', state: 'MT', lat: 45.8170, lon: -110.8970 },
    { name: 'Taos Ski Valley', state: 'NM', lat: 36.5968, lon: -105.4500 },
    { name: 'Ski Santa Fe', state: 'NM', lat: 35.7966, lon: -105.8020 },
    { name: 'Arizona Snowbowl', state: 'AZ', lat: 35.3310, lon: -111.7110 },
    { name: 'Palisades Tahoe', state: 'CA', lat: 39.1968, lon: -120.2354 },
    { name: 'Heavenly', state: 'CA', lat: 38.9353, lon: -119.9400 },
    { name: 'Mammoth Mountain', state: 'CA', lat: 37.6510, lon: -119.0370 },
    { name: 'Kirkwood', state: 'CA', lat: 38.6847, lon: -120.0652 },
    { name: 'Northstar California', state: 'CA', lat: 39.2746, lon: -120.1210 },
    { name: 'Mt. Bachelor', state: 'OR', lat: 43.9790, lon: -121.6870 },
    { name: 'Timberline Lodge', state: 'OR', lat: 45.3311, lon: -121.7110 },
    { name: 'Mt. Hood Meadows', state: 'OR', lat: 45.3310, lon: -121.6650 },
    { name: 'Crystal Mountain', state: 'WA', lat: 46.9350, lon: -121.4740 },
    { name: 'Stevens Pass', state: 'WA', lat: 47.7450, lon: -121.0890 },
    { name: 'The Summit at Snoqualmie', state: 'WA', lat: 47.4240, lon: -121.4140 },
    { name: 'Mt. Baker', state: 'WA', lat: 48.8570, lon: -121.6660 },
    { name: 'Alyeska', state: 'AK', lat: 60.9700, lon: -149.0980 },
    { name: 'Killington', state: 'VT', lat: 43.6045, lon: -72.8201 },
    { name: 'Stowe', state: 'VT', lat: 44.5294, lon: -72.7815 },
    { name: 'Sugarbush', state: 'VT', lat: 44.1359, lon: -72.8946 },
    { name: 'Jay Peak', state: 'VT', lat: 44.9379, lon: -72.5046 },
    { name: 'Okemo', state: 'VT', lat: 43.4018, lon: -72.7178 },
    { name: 'Stratton', state: 'VT', lat: 43.1142, lon: -72.9062 },
    { name: 'Mount Snow', state: 'VT', lat: 42.9600, lon: -72.9200 },
    { name: 'Whiteface', state: 'NY', lat: 44.3530, lon: -73.8610 },
    { name: 'Gore Mountain', state: 'NY', lat: 43.6720, lon: -74.0060 },
    { name: 'Sunday River', state: 'ME', lat: 44.4734, lon: -70.8568 },
    { name: 'Sugarloaf', state: 'ME', lat: 45.0314, lon: -70.3131 },
    { name: 'Loon Mountain', state: 'NH', lat: 44.0564, lon: -71.6339 },
    { name: 'Bretton Woods', state: 'NH', lat: 44.2580, lon: -71.4410 },
    { name: 'Cannon Mountain', state: 'NH', lat: 44.1567, lon: -71.6980 },
    { name: 'Whistler Blackcomb', state: 'BC', lat: 50.1149, lon: -122.9480 },
    { name: 'Revelstoke', state: 'BC', lat: 50.9583, lon: -118.1636 },
    { name: 'Kicking Horse', state: 'BC', lat: 51.2970, lon: -117.0480 },
    { name: 'Big White', state: 'BC', lat: 49.7210, lon: -118.9280 },
    { name: 'SilverStar', state: 'BC', lat: 50.3600, lon: -119.0590 },
    { name: 'Fernie', state: 'BC', lat: 49.4620, lon: -115.0850 },
    { name: 'RED Mountain', state: 'BC', lat: 49.1020, lon: -117.8190 },
    { name: 'Lake Louise', state: 'AB', lat: 51.4410, lon: -116.1620 },
    { name: 'Banff Sunshine', state: 'AB', lat: 51.1150, lon: -115.7630 },
    { name: 'Mont Tremblant', state: 'QC', lat: 46.2120, lon: -74.5850 }
  ];

  const SICK_DAY_EXCUSES = [
    "I woke up, and decided I am not going to work today. Sorry.",
    "My butthole hurts and I need to stay home.",
    "My dog ate my alarm clock and I overslept. I'm going to need to call out today.",
    "I have to go pick up my friend from the airport, he's really counting on me and I can't let him down.",
    "I forgot I had something else to do and now I'm doing that and not working",
    "I fell down the stairs and my shoes fell off :(",
    "I am currently stuck in my dryer and need to take the day to figure out how to get out.",
    "My diaper is full and I have my nurse coming to change it, probably gonna take all day.",
    "My house exploded.",
    "It's nuking outside, I'm not coming to work buddy...",
    "I thought about planning on going to work today, but the plan fell through.",
    "I am scared of the dark so I didn't sleep and now I am too tired to be productive.",
    "My car broke down and I think it needs blinker fluid.",
    "I am hiding under my bed and don't feel safe coming out just yet.",
    "I shit my pants.",
    "A moose ran through my front door and killed my roommate, gotta plan his funeral.",
    "I am out of cigarettes, therefore I cannot function today.",
    "Whatever excuse you'll believe, thats what happened.",
    "I woke up sick AF 😎",
    "I'm hammered right now, so asking me to drive to work is just irresponsible on your part",
    "I hurt my ego yesterday and need a day to recover.",
    "My tummy hurts and I need gummy bears :(",
    "Something is wrong in my gut, and I could shit through a screen door right now. Not coming to work.",
    "My phone is dead and so is my computer, I bet.",
    "I pissed the bed again, so I need to stay home and clean this up. It's a lot",
    "Skool is 4 chumps",
    "Sorry boss man, only losers have jobs 🖕🖕🖕",
    "Something came up, and I'm busy now",
    "My land lord is coming to fix my entire house, it will be a while",
    "A man broke into my house and stole my work computer, but he was at least nice enough to send this message.",
    "My head was bashed apart..."
  ];

  function init(root = document) {
    const sections = root.matches?.('[data-dawg-report]') ? [root] : root.querySelectorAll('[data-dawg-report]');
    sections.forEach((section) => {
      if (section.dataset.dawgReportReady === 'true') return;
      section.dataset.dawgReportReady = 'true';
      updateSummerEasterEgg(section);

      const trigger = section.querySelector('[data-dawg-report-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', () => handlePrimaryAction(section));

      const moreTrigger = section.querySelector('[data-dawg-report-more]');
      if (moreTrigger) {
        moreTrigger.addEventListener('click', () => loadMoreResorts(section));
      }
    });
  }

  function updateSummerEasterEgg(section, date = new Date()) {
    const message = section.querySelector('[data-dawg-report-summer]');
    const month = date.getMonth();
    const isSummer = month >= 5 && month <= 7;

    if (message) {
      if (section.dawgReportOriginalSummerHtml === undefined) {
        section.dawgReportOriginalSummerHtml = message.innerHTML;
      }

      message.hidden = !isSummer;
      if (!isSummer) return;

      if (section.classList.contains('should-call-in-sick--has-results')) {
        message.textContent = 'okay here\'s the "snow" on the horizon, hope you find help soon.';
      } else {
        message.innerHTML = section.dawgReportOriginalSummerHtml;
      }
    }
  }

  function handlePrimaryAction(section) {
    if (section.dataset.dawgReportMode === 'excuse') {
      showExcuse(section);
      return;
    }

    requestForecast(section);
  }

  async function requestForecast(section) {
    const trigger = section.querySelector('[data-dawg-report-trigger]');

    if (!navigator.geolocation) {
      setStatus(section, 'Your browser does not support location lookup.', 'error');
      return;
    }

    setBusy(section, true);
    setStatus(section, 'Sniffing, and sniffing hard. Hold tight.', 'loading');
    clearResults(section);

    try {
      const position = await getPosition();
      const nearby = getNearbyResorts(
        position.coords.latitude,
        position.coords.longitude,
        getNumber(section.dataset.searchRadius, 250)
      );

      if (!nearby.length) {
        throw new Error('No ski areas found.');
      }

      setStatus(section, 'Sniffing snow, wind, and viable excuses...', 'loading');

      const forecastHours = getNumber(section.dataset.forecastHours, 48);
      section.dawgReportState = {
        resorts: nearby,
        loadedCount: 0,
        pageSize: getNumber(section.dataset.maxResults, 3),
        forecastHours,
        usedFallback: nearby.usedFallback
      };

      await loadNextResorts(section, { reset: true });
      revealReportProducts();
      setStatus(section, '', null, true);
    } catch (error) {
      const message = getFriendlyError(error);
      setStatus(section, message, 'error');
    } finally {
      setBusy(section, false);
      if (trigger) trigger.blur();
    }
  }

  function getPosition() {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: false,
        maximumAge: 15 * 60 * 1000,
        timeout: 10000
      });
    });
  }

  function getNearbyResorts(lat, lon, radius) {
    const sorted = RESORTS
      .map((resort) => ({
        ...resort,
        distance: haversineMiles(lat, lon, resort.lat, resort.lon)
      }))
      .sort((a, b) => a.distance - b.distance);

    const withinRadius = sorted.filter((resort) => resort.distance <= radius);
    const selected = withinRadius.length ? withinRadius : sorted;

    selected.usedFallback = withinRadius.length === 0;
    return selected;
  }

  async function loadMoreResorts(section) {
    const state = section.dawgReportState;

    if (!state) return;

    setStatus(section, 'Sniffing farther down the mountain road...', 'loading');

    try {
      await loadNextResorts(section, { reset: false });
      setStatus(section, '', null, true);
    } catch (_error) {
      setStatus(section, 'Could not sniff more resorts right now. Try again in a minute.', 'error');
    }
  }

  async function loadNextResorts(section, { reset = false } = {}) {
    const state = section.dawgReportState;

    if (!state) return;

    const nextResorts = state.resorts.slice(state.loadedCount, state.loadedCount + state.pageSize);

    if (!nextResorts.length) {
      updateMoreButton(section);
      return;
    }

    setMoreBusy(section, true);

    try {
      const settled = await Promise.allSettled(
        nextResorts.map((resort) => fetchResortForecast(resort, state.forecastHours))
      );
      const reports = settled
        .filter((result) => result.status === 'fulfilled')
        .map((result) => result.value);

      if (!reports.length) {
        throw new Error('Forecast unavailable.');
      }

      state.loadedCount += nextResorts.length;
      renderResults(section, reports, state.forecastHours, reset && state.usedFallback, !reset);
      updateMoreButton(section);
    } finally {
      setMoreBusy(section, false);
    }
  }

  async function fetchResortForecast(resort, forecastHours) {
    const cacheKey = `${CACHE_PREFIX}:${resort.lat}:${resort.lon}:${forecastHours}`;
    const cached = getCache(cacheKey);

    if (cached) {
      return buildReport(resort, cached, forecastHours);
    }

    const url = new URL(FORECAST_ENDPOINT);
    url.search = new URLSearchParams({
      latitude: resort.lat,
      longitude: resort.lon,
      current: 'temperature_2m,wind_speed_10m,wind_gusts_10m,weather_code',
      hourly: 'temperature_2m,snowfall,wind_speed_10m,wind_gusts_10m,weather_code',
      daily: 'snowfall_sum,temperature_2m_min,temperature_2m_max,wind_speed_10m_max',
      temperature_unit: 'fahrenheit',
      wind_speed_unit: 'mph',
      precipitation_unit: 'inch',
      timezone: 'auto',
      forecast_days: '3',
      forecast_hours: String(Math.max(forecastHours, 48))
    });

    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 10000);

    try {
      const response = await fetch(url.toString(), { signal: controller.signal });

      if (!response.ok) {
        throw new Error(`Forecast failed with ${response.status}`);
      }

      const data = await response.json();
      setCache(cacheKey, data);
      return buildReport(resort, data, forecastHours);
    } finally {
      window.clearTimeout(timer);
    }
  }

  function buildReport(resort, data, forecastHours) {
    const hourly = data.hourly || {};
    const hoursToRead = Math.min(forecastHours, hourly.time?.length || 0);
    const snowfall = sumValues(hourly.snowfall, hoursToRead);
    const wind = maxValue(hourly.wind_speed_10m, hoursToRead, data.current?.wind_speed_10m || 0);
    const gust = maxValue(hourly.wind_gusts_10m, hoursToRead, data.current?.wind_gusts_10m || wind);
    const temp = firstNumber(data.current?.temperature_2m, averageNext(hourly.temperature_2m, 6));
    const bestWindow = getBestWindow(hourly, forecastHours);
    const forecast = getForecastSummary(hourly.weather_code, hoursToRead, snowfall, wind, data.current?.weather_code);
    const score = getPowderScore(snowfall, temp, wind);

    return {
      resort,
      forecast,
      snowfall,
      wind,
      gust,
      temp,
      bestWindow,
      score,
      scoreLabel: getScoreLabel(score),
      windLabel: getWindLabel(wind),
      fit: getFit(temp, wind, snowfall)
    };
  }

  function renderResults(section, reports, forecastHours, usedFallback, append = false) {
    const empty = section.querySelector('[data-dawg-report-empty]');
    const results = section.querySelector('[data-dawg-report-results]');

    if (empty) empty.hidden = true;
    if (!results) return;

    if (!append) {
      section.classList.add('should-call-in-sick--has-results');
      activateExcuseMode(section);
    }

    results.hidden = false;
    if (!append) {
      disposeCameraCards(results);
      results.innerHTML = '';
    }

    if (usedFallback && !append) {
      const note = document.createElement('p');
      note.className = 'should-call-in-sick__status';
      note.textContent = 'No ski areas found inside your radius, so here are the closest Dawg Report hits.';
      results.append(note);
    }

    reports.forEach((report) => {
      const card = document.createElement('article');
      card.className = 'should-call-in-sick__card';
      card.innerHTML = `
        <div class="should-call-in-sick__card-header">
          <div>
            <h3 class="should-call-in-sick__resort">
              <span class="should-call-in-sick__forecast-icon should-call-in-sick__forecast-icon--${escapeHtml(report.forecast.kind)}" role="img" aria-label="${escapeHtml(report.forecast.label)} forecast">
                ${getForecastIcon(report.forecast.kind)}
              </span>
              <span class="should-call-in-sick__resort-name">${escapeHtml(report.resort.name)}</span>
            </h3>
            <span class="should-call-in-sick__distance">${escapeHtml(report.resort.state)} - ${Math.round(report.resort.distance)} mi away</span>
          </div>
          <div class="should-call-in-sick__score">
            <span class="should-call-in-sick__score-context">sick-day odds</span>
            <span class="should-call-in-sick__score-value">${report.score}/10</span>
            <span class="should-call-in-sick__score-label">${escapeHtml(report.scoreLabel)}</span>
          </div>
        </div>
        <dl class="should-call-in-sick__facts">
          <div class="should-call-in-sick__fact">
            <span>Snow next ${forecastHours} hr</span>
            <strong>${escapeHtml(formatSnow(report.snowfall))}</strong>
          </div>
          <div class="should-call-in-sick__fact">
            <span>Wind</span>
            <strong>${escapeHtml(report.windLabel)} (${Math.round(report.wind)} mph)</strong>
          </div>
          <div class="should-call-in-sick__fact">
            <span>Temp</span>
            <strong>${formatTemp(report.temp)}</strong>
          </div>
          <div class="should-call-in-sick__fact">
            <span>Peak snow window</span>
            <strong>${escapeHtml(report.bestWindow)}</strong>
          </div>
        </dl>
        <p class="should-call-in-sick__fit"><strong>Recommended fit:</strong> ${formatFit(report.fit)}</p>
      `;

      const snowFact = card.querySelector('.should-call-in-sick__fact strong');
      if (snowFact) {
        snowFact.setAttribute('aria-label', `${snowFact.textContent} expected in the next ${forecastHours} hours`);
      }

      results.append(card);
      initCameraCard(section, card, report.resort);
    });
  }

  function initCameraCard(section, card, resort) {
    const report = document.createElement('div');
    report.className = 'should-call-in-sick__card-page should-call-in-sick__card-report';
    report.append(...card.childNodes);

    const viewport = document.createElement('div');
    viewport.className = 'should-call-in-sick__card-viewport';
    const track = document.createElement('div');
    track.className = 'should-call-in-sick__card-track';
    const cameras = document.createElement('div');
    cameras.className = 'should-call-in-sick__card-page should-call-in-sick__card-cameras';
    cameras.id = `DawgCams-${section.dataset.sectionId}-${++cameraPanelId}`;
    cameras.setAttribute('role', 'region');
    cameras.setAttribute('aria-label', `${resort.name} mountain cams`);
    cameras.setAttribute('aria-hidden', 'true');
    cameras.inert = true;
    cameras.innerHTML = `
      <div class="should-call-in-sick__cams-heading">
        <div>
          <p class="should-call-in-sick__cams-kicker">A look up the mountain</p>
          <h3>${escapeHtml(resort.name)} cams</h3>
        </div>
        <button type="button" class="should-call-in-sick__cams-reload">Reload cams</button>
      </div>
      <p class="should-call-in-sick__cams-status" role="status"></p>
      <div class="should-call-in-sick__cam-grid"></div>
      <p class="should-call-in-sick__cams-help">Feed blank or offline? <a hidden target="_blank" rel="noopener noreferrer">Open the resort’s cams ↗</a></p>
    `;

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'should-call-in-sick__cam-toggle';
    toggle.setAttribute('aria-controls', cameras.id);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', `Check cams at ${resort.name}`);
    toggle.innerHTML = '<span>Check cams</span><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 5 7 7-7 7"/></svg>';
    track.append(report, cameras);
    viewport.append(track);
    card.append(viewport, toggle);

    const grid = cameras.querySelector('.should-call-in-sick__cam-grid');
    const status = cameras.querySelector('.should-call-in-sick__cams-status');
    const resortLink = cameras.querySelector('.should-call-in-sick__cams-help a');
    const reload = cameras.querySelector('.should-call-in-sick__cams-reload');
    let open = false;
    let disposed = false;
    let loadId = 0;

    function updateHeight() {
      if (!disposed && card.isConnected) {
        track.style.setProperty('--dawg-report-height', `${report.offsetHeight}px`);
        viewport.style.height = `${(open ? cameras : report).offsetHeight}px`;
      }
    }

    async function loadCameras() {
      const requestId = ++loadId;
      grid.replaceChildren();
      status.textContent = 'Sniffing out the mountain views…';
      reload.disabled = true;
      updateHeight();

      try {
        const sources = await getCameraSources(section);
        if (disposed || !open || requestId !== loadId) return;
        const source = sources.resorts?.[resort.name];
        const feeds = (source?.cameras || []).filter((camera) =>
          ['iframe', 'image'].includes(camera.type) && isCameraUrl(camera.url)
        ).slice(0, 4);

        resortLink.hidden = !isCameraUrl(source?.pageUrl);
        if (!resortLink.hidden) {
          resortLink.href = source.pageUrl;
          resortLink.textContent = source.pageLabel || 'Open the resort’s cams ↗';
        }
        status.textContent = !feeds.length
          ? 'No embedded feeds available here yet. Try the resort site for more mountain views.'
          : feeds.some((camera) => camera.type === 'image' || camera.startWithSnapshot)
            ? 'Views from the resort. Snapshots update when you reload cams; use a player for video.'
            : 'Views from the resort. Tap a player to watch.';
        feeds.forEach((camera) => grid.append(createCameraTile(camera, resort.name, source.pageUrl)));
      } catch (_error) {
        if (disposed || !open || requestId !== loadId) return;
        status.textContent = 'The camera list could not load. Give it another sniff.';
      } finally {
        if (!disposed && open && requestId === loadId) {
          reload.disabled = false;
          updateHeight();
        }
      }
    }

    function setOpen(nextOpen) {
      open = nextOpen;
      card.classList.toggle('is-showing-cams', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? `Back to ${resort.name} report` : `Check cams at ${resort.name}`);
      toggle.querySelector('span').textContent = open ? 'Back to report' : 'Check cams';
      report.inert = open;
      report.setAttribute('aria-hidden', String(open));
      cameras.inert = !open;
      cameras.setAttribute('aria-hidden', String(!open));
      if (open) {
        loadCameras();
      } else {
        loadId += 1;
        // Removing the players stops playback and third-party requests on the hidden side.
        grid.replaceChildren();
      }
      updateHeight();
    }

    toggle.addEventListener('click', () => setOpen(!open));
    reload.addEventListener('click', loadCameras);
    card.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !open) return;
      event.preventDefault();
      setOpen(false);
      toggle.focus();
    });
    const observer = new ResizeObserver(updateHeight);
    observer.observe(report);
    observer.observe(cameras);
    card.dawgCameraDispose = () => {
      disposed = true;
      loadId += 1;
      observer.disconnect();
      grid.replaceChildren();
    };
    updateHeight();
  }

  async function getCameraSources(section) {
    if (!cameraSourcesRequest) {
      cameraSourcesRequest = (async () => {
        const controller = new AbortController();
        const timer = window.setTimeout(() => controller.abort(), 8000);
        try {
          const response = await fetch(section.dataset.cameraSourcesUrl, { signal: controller.signal });
          if (!response.ok) throw new Error('Camera list unavailable.');
          return await response.json();
        } finally {
          window.clearTimeout(timer);
        }
      })().catch((error) => {
        cameraSourcesRequest = null;
        throw error;
      });
    }
    return cameraSourcesRequest;
  }

  function isCameraUrl(value) {
    try {
      return new URL(value).protocol === 'https:';
    } catch (_error) {
      return false;
    }
  }

  function createCameraTile(camera, resortName, pageUrl) {
    const tile = document.createElement('figure');
    tile.className = 'should-call-in-sick__cam';
    const media = document.createElement('div');
    media.className = 'should-call-in-sick__cam-media';
    const feed = document.createElement(camera.type === 'image' ? 'img' : 'iframe');
    const label = `${resortName}: ${camera.title}`;
    if (camera.type === 'image') {
      feed.alt = label;
      feed.decoding = 'async';
    } else {
      feed.title = label;
      feed.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      feed.allowFullscreen = true;
      feed.referrerPolicy = 'strict-origin-when-cross-origin';
    }
    feed.addEventListener('error', () => {
      feed.remove();
      media.textContent = 'This feed is unavailable. Open the resort’s cams below.';
      media.classList.add('is-unavailable');
    }, { once: true });
    const url = new URL(camera.url);
    if (camera.type === 'image') url.searchParams.set('_dawg', Date.now());
    feed.setAttribute('src', url.toString());
    media.append(feed);
    const caption = document.createElement('figcaption');
    const title = document.createElement('a');
    title.textContent = camera.title;
    title.href = isCameraUrl(pageUrl) ? pageUrl : camera.url;
    title.target = '_blank';
    title.rel = 'noopener noreferrer';
    const kind = document.createElement('span');
    kind.textContent = camera.type === 'image' ? 'Snapshot' : camera.kind || 'Resort player';
    caption.append(title, kind);
    let snapshotControl;
    if (camera.type === 'iframe' && isCameraUrl(camera.fallbackUrl)) {
      const snapshot = document.createElement('button');
      snapshotControl = snapshot;
      snapshot.type = 'button';
      snapshot.className = 'should-call-in-sick__cam-snapshot';
      snapshot.textContent = 'Show snapshot';
      snapshot.setAttribute('aria-label', `Show snapshot of ${label}`);
      let showingSnapshot = false;
      snapshot.addEventListener('click', () => {
        if (showingSnapshot) {
          media.classList.remove('is-unavailable');
          media.replaceChildren(feed);
          kind.textContent = camera.kind || 'Resort player';
          snapshot.textContent = 'Show snapshot';
          snapshot.setAttribute('aria-label', `Show snapshot of ${label}`);
          showingSnapshot = false;
          return;
        }
        const image = document.createElement('img');
        image.alt = label;
        image.decoding = 'async';
        const snapshotUrl = new URL(camera.fallbackUrl);
        snapshotUrl.searchParams.set('_dawg', Date.now());
        image.src = snapshotUrl;
        image.addEventListener('error', () => {
          media.textContent = 'Snapshot unavailable. Open the resort’s cams below.';
          media.classList.add('is-unavailable');
        }, { once: true });
        media.classList.remove('is-unavailable');
        media.replaceChildren(image);
        kind.textContent = 'Snapshot';
        snapshot.textContent = 'Show player';
        snapshot.setAttribute('aria-label', `Show player for ${label}`);
        showingSnapshot = true;
      });
      caption.append(snapshot);
    }
    tile.append(media, caption);
    if (camera.startWithSnapshot) snapshotControl?.click();
    return tile;
  }

  function disposeCameraCards(root) {
    root.querySelectorAll('.should-call-in-sick__card').forEach((card) => card.dawgCameraDispose?.());
  }

  function activateExcuseMode(section) {
    section.dataset.dawgReportMode = 'excuse';
    updateTriggerLabel(section, getExcuseButtonLabel(section));
    updateIntroCopy(section, '<p>The report is in. If your sick-day odds look promising, we have excuses ready.</p>');
    updateSummerEasterEgg(section);
  }

  function resetPrimaryMode(section) {
    section.classList.remove('should-call-in-sick--has-results');
    section.dataset.dawgReportMode = 'forecast';
    updateTriggerLabel(section, getDefaultButtonLabel(section));
    updateIntroCopy(section, null);
    hideExcuse(section);
    updateSummerEasterEgg(section);
  }

  function showExcuse(section) {
    const excuse = getRandomExcuse(section);
    const output = section.querySelector('[data-dawg-report-excuse]');

    if (!output) return;

    output.hidden = false;
    output.innerHTML = `
      <p class="should-call-in-sick__excuse-kicker">Potential Excuse...</p>
      <p class="should-call-in-sick__excuse-copy">${escapeHtml(excuse)}</p>
    `;
  }

  function hideExcuse(section) {
    const output = section.querySelector('[data-dawg-report-excuse]');

    if (!output) return;

    output.hidden = true;
    output.innerHTML = '';
  }

  function getRandomExcuse(section) {
    const previousIndex = Number(section.dataset.dawgReportExcuseIndex);
    let index = Math.floor(Math.random() * SICK_DAY_EXCUSES.length);

    if (SICK_DAY_EXCUSES.length > 1 && index === previousIndex) {
      index = (index + 1) % SICK_DAY_EXCUSES.length;
    }

    section.dataset.dawgReportExcuseIndex = String(index);
    return SICK_DAY_EXCUSES[index];
  }

  function updateTriggerLabel(section, label) {
    const labelNode = section.querySelector('[data-dawg-report-trigger-label]');

    if (labelNode) {
      labelNode.textContent = label;
    }
  }

  function getDefaultButtonLabel(section) {
    const trigger = section.querySelector('[data-dawg-report-trigger]');
    return trigger?.dataset.dawgReportDefaultLabel || 'Sniff out powder';
  }

  function getExcuseButtonLabel(section) {
    const trigger = section.querySelector('[data-dawg-report-trigger]');
    return trigger?.dataset.dawgReportExcuseLabel || 'Give me a viable excuse';
  }

  function updateIntroCopy(section, html) {
    const intro = section.querySelector('[data-dawg-report-intro-text]');

    if (!intro) return;

    if (section.dawgReportOriginalIntroHtml === undefined) {
      section.dawgReportOriginalIntroHtml = intro.innerHTML;
    }

    intro.innerHTML = html || section.dawgReportOriginalIntroHtml;
  }

  function setBusy(section, isBusy) {
    const trigger = section.querySelector('[data-dawg-report-trigger]');

    if (!trigger) return;

    trigger.disabled = isBusy;
    trigger.setAttribute('aria-busy', String(isBusy));
  }

  function setMoreBusy(section, isBusy) {
    const trigger = section.querySelector('[data-dawg-report-more]');

    if (!trigger) return;

    trigger.disabled = isBusy;
    trigger.setAttribute('aria-busy', String(isBusy));
  }

  function updateMoreButton(section) {
    const state = section.dawgReportState;
    const wrapper = section.querySelector('[data-dawg-report-more-wrapper]');
    const trigger = section.querySelector('[data-dawg-report-more]');

    if (!wrapper || !trigger || !state) return;

    const hasMore = state.loadedCount < state.resorts.length;
    wrapper.hidden = !hasMore;
    trigger.disabled = !hasMore;
  }

  function revealReportProducts() {
    document.querySelectorAll('[data-dawg-report-products]').forEach((section) => {
      section.hidden = false;
      section.classList.add('is-visible');
    });
  }

  function setStatus(section, message, type, hide = false) {
    const status = section.querySelector('[data-dawg-report-status]');
    const statusText = section.querySelector('[data-dawg-report-status-text]');

    if (!status) return;

    status.hidden = hide;
    if (statusText) {
      statusText.textContent = message || '';
    } else {
      status.textContent = message || '';
    }
    status.classList.toggle('is-loading', type === 'loading');
    status.classList.toggle('is-error', type === 'error');
  }

  function clearResults(section) {
    const empty = section.querySelector('[data-dawg-report-empty]');
    const results = section.querySelector('[data-dawg-report-results]');
    const moreWrapper = section.querySelector('[data-dawg-report-more-wrapper]');

    resetPrimaryMode(section);

    if (empty) empty.hidden = true;
    if (results) {
      disposeCameraCards(results);
      results.hidden = true;
      results.innerHTML = '';
    }
    if (moreWrapper) {
      moreWrapper.hidden = true;
    }
  }

  function getFriendlyError(error) {
    if (error?.code === 1) return 'Location access was blocked. Enable location and try again.';
    if (error?.code === 2) return 'Could not get your location. Try again from a stronger connection.';
    if (error?.code === 3) return 'Location lookup timed out. Give it another sniff.';
    return 'The Dawg Report could not fetch powder right now. Try again in a minute.';
  }

  function getPowderScore(snowfall, temp, wind) {
    const snowPoints = Math.min(6, snowfall * 0.75);
    const tempPoints = temp <= 10 ? 1 : temp <= 30 ? 2 : temp <= 36 ? 1.25 : temp <= 42 ? 0.5 : 0;
    const windPoints = wind <= 12 ? 2 : wind <= 24 ? 1.25 : wind <= 35 ? 0.4 : -0.5;

    return clamp(Math.round(snowPoints + tempPoints + windPoints), 1, 10);
  }

  function getScoreLabel(score) {
    if (score >= 8) return 'You are calling in sick';
    if (score >= 6) return 'Dawgs are comin\' out to play';
    if (score >= 4) return 'Groomer Cruiser';
    return 'Not missing much';
  }

  function getWindLabel(wind) {
    if (wind < 8) return 'calm';
    if (wind < 16) return 'mellow';
    if (wind < 26) return 'moderate';
    if (wind < 36) return 'spicy';
    return 'full howl';
  }

  function getForecastSummary(codes = [], count = codes.length, snowfall = 0, wind = 0, currentCode) {
    const usableCodes = codes
      .slice(0, count)
      .map(Number)
      .filter(Number.isFinite);
    const current = Number(currentCode);

    if (Number.isFinite(current)) {
      usableCodes.unshift(current);
    }

    if (snowfall >= 0.1 || usableCodes.some(isSnowCode)) return { kind: 'snow', label: 'Snowy' };
    if (usableCodes.some(isStormCode)) return { kind: 'storm', label: 'Stormy' };
    if (usableCodes.some(isRainCode)) return { kind: 'rain', label: 'Rainy' };
    if (usableCodes.some((code) => code === 45 || code === 48)) return { kind: 'fog', label: 'Foggy' };
    if (wind >= 26) return { kind: 'wind', label: 'Windy' };
    if (usableCodes.some((code) => code >= 2 && code <= 3)) return { kind: 'cloud', label: 'Cloudy' };
    if (usableCodes.some((code) => code === 0 || code === 1)) return { kind: 'clear', label: 'Clear' };

    return { kind: 'cloud', label: 'Mixed' };
  }

  function isSnowCode(code) {
    return [71, 73, 75, 77, 85, 86].includes(code);
  }

  function isRainCode(code) {
    return [51, 53, 55, 56, 57, 61, 63, 65, 66, 67, 80, 81, 82].includes(code);
  }

  function isStormCode(code) {
    return [95, 96, 99].includes(code);
  }

  function getForecastIcon(kind) {
    const icons = {
      clear: `
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <circle cx="12" cy="12" r="4"></circle>
          <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M19.8 4.2l-2.1 2.1M6.3 17.7l-2.1 2.1"></path>
        </svg>
      `,
      cloud: `
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M7 18h10.2a4.3 4.3 0 0 0 .6-8.6A6 6 0 0 0 6.4 11 3.5 3.5 0 0 0 7 18Z"></path>
        </svg>
      `,
      fog: `
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M5 8h14M3 12h18M5 16h14M8 20h8"></path>
        </svg>
      `,
      rain: `
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M7 14h10.2a4 4 0 0 0 .4-8A5.5 5.5 0 0 0 7 8.2 3 3 0 0 0 7 14Z"></path>
          <path d="M8 18l-1 3M13 18l-1 3M18 18l-1 3"></path>
        </svg>
      `,
      snow: `
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M12 3v18M4.2 7.5l15.6 9M4.2 16.5l15.6-9"></path>
          <path d="M9 5l3 2 3-2M9 19l3-2 3 2"></path>
        </svg>
      `,
      storm: `
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M7 13h10.2a4 4 0 0 0 .4-8A5.5 5.5 0 0 0 7 7.2 3 3 0 0 0 7 13Z"></path>
          <path d="M12 13l-3 5h3l-1 4 4-6h-3l2-3Z" fill="currentColor" stroke="none"></path>
        </svg>
      `,
      wind: `
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M3 8h11a3 3 0 1 0-3-3M3 13h16M3 18h12a3 3 0 1 1-3 3"></path>
        </svg>
      `
    };

    return icons[kind] || icons.cloud;
  }

  function getFit(temp, wind, snowfall) {
    if (temp <= 12 || wind >= 28) return 'Shred Suit + heavyweight base layer + face cover';
    if (temp <= 28 || snowfall >= 4) return 'Shred Suit + base layer';
    if (temp <= 36 || snowfall >= 1) return 'Hot Dawg Half-Zip and some basic snowpants';
    if (temp > 36 && temp <= 55) return 'Hot Dawg Half-Zip and Jorts';
    return 'Might as well ski naked';
  }

  function getBestWindow(hourly, forecastHours) {
    const times = hourly.time || [];
    const snow = hourly.snowfall || [];
    const hoursToRead = Math.min(forecastHours, times.length, snow.length);
    let bestIndex = -1;
    let bestSnow = 0;

    for (let index = 0; index < hoursToRead; index += 1) {
      const value = Number(snow[index]) || 0;
      if (value > bestSnow) {
        bestSnow = value;
        bestIndex = index;
      }
    }

    if (bestIndex === -1 || bestSnow < 0.05) {
      return 'No pow on the horizon :(';
    }

    const date = new Date(times[bestIndex]);
    const hour = date.getHours();
    const period = hour < 12 ? 'morning' : hour < 17 ? 'afternoon' : hour < 21 ? 'evening' : 'overnight';

    return `${getDayLabel(date)} ${period}`;
  }

  function getDayLabel(date) {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    if (date.toDateString() === today.toDateString()) return 'Today';
    if (date.toDateString() === tomorrow.toDateString()) return 'Tomorrow';

    return date.toLocaleDateString(undefined, { weekday: 'long' });
  }

  function formatSnow(total) {
    if (total < 0.1) return 'No real accumulation';
    if (total < 1) return 'Trace to 1 in';

    const low = Math.max(1, Math.floor(total * 0.8));
    const high = Math.max(low + 1, Math.ceil(total * 1.25));

    return `${low}-${high} in`;
  }

  function formatTemp(temp) {
    if (!Number.isFinite(temp)) return 'N/A';
    return `${Math.round(temp)}\u00b0F`;
  }

  function formatFit(fit) {
    return escapeHtml(fit)
      .replace(/Shred Suit/g, `<a href="${SHRED_SUIT_URL}">Shred Suit</a>`)
      .replace(/Hot Dawg Half-Zip/g, `<a href="${HALF_ZIP_URL}">Hot Dawg Half-Zip</a>`);
  }

  function haversineMiles(lat1, lon1, lat2, lon2) {
    const radius = 3958.8;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    return radius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function toRad(value) {
    return value * Math.PI / 180;
  }

  function sumValues(values = [], count = values.length) {
    return values.slice(0, count).reduce((sum, value) => sum + (Number(value) || 0), 0);
  }

  function maxValue(values = [], count = values.length, fallback = 0) {
    const usable = values.slice(0, count).map(Number).filter(Number.isFinite);
    return usable.length ? Math.max(...usable) : fallback;
  }

  function averageNext(values = [], count = 6) {
    const usable = values.slice(0, count).map(Number).filter(Number.isFinite);
    if (!usable.length) return NaN;
    return usable.reduce((sum, value) => sum + value, 0) / usable.length;
  }

  function firstNumber(...values) {
    return values.find(Number.isFinite) ?? NaN;
  }

  function getNumber(value, fallback) {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function getCache(key) {
    try {
      const raw = window.sessionStorage.getItem(key);
      if (!raw) return null;

      const cached = JSON.parse(raw);
      if (!cached?.createdAt || Date.now() - cached.createdAt > CACHE_TTL) {
        window.sessionStorage.removeItem(key);
        return null;
      }

      return cached.data;
    } catch (_error) {
      return null;
    }
  }

  function setCache(key, data) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify({
        createdAt: Date.now(),
        data
      }));
    } catch (_error) {
      // Forecast still works without cache.
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  window[INIT_FN] = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => disposeCameraCards(event.target));
})();
